export default __webpack_public_path__ + "static/media/mainx2.4930275f.png";